import TabButton from '../../../../Components/TabButton/TabButton';
import { useDispatch, useSelector } from 'react-redux';
import { changeProfileTab } from '../../../../Features/lensSlice';
import PostBox from './PostBox';
import { useEffect, useState } from 'react';

function ProfilePostGrid() {
    const dispatch = useDispatch();
    const activeProfileTab = useSelector((state) => state.lens.activeProfileTab);

    const defaultLensData = {
        posts: [],
        reviews: [],
    }

    const [lensData, setLensData] = useState(defaultLensData);

    const { sellerInfo } = useSelector((state) => state.lens.sellerInfo);
    const { storeData } = useSelector((state) => state.lens.storeData);
    const { sellerReviews } = useSelector((state) => state.lens.sellerReviews);

    const updateActiveTab = (selection) => {
        dispatch(changeProfileTab(selection));
    }

    // useEffect(() => {
    //     if(sellerInfo?.id === storeData?.id) {
    //         console.log(sellerInfo?.posts);
    //         console.log(sellerReviews)
    //         // Set store lens
    //         setLensData({
    //             posts: sellerInfo?.posts,
    //             reviews: sellerReviews,
    //         });
    //     }
    //     else {
    //         // Set user lens
    //         setLensData({
    //             posts: [ ...sellerInfo?.posts, ...sellerReviews],
    //             reviews: [],
    //         });
    //     }
    // }, [sellerInfo, storeData, sellerReviews]);

    return (
        <div className="flex flex-col gap-4 mt-4 mx-5">
            <div className="flex mx-auto">
                <TabButton 
                    id='posts' 
                    optionName='Posts' 
                    selected={activeProfileTab} 
                    handleSelect={updateActiveTab} 
                />

                {
                    sellerInfo.id === storeData.id && 
                    <TabButton 
                        id='reviews' 
                        optionName='Customer Reviews' 
                        selected={activeProfileTab} 
                        handleSelect={updateActiveTab} 
                    />
                }
            </div>

            <div className='mx-auto'>
                <div className="cursor-pointer w-fit grid grid-cols-3 gap-x-2 gap-y-2">
                    {
                        activeProfileTab === 'posts' && 
                        <>
                            {
                                sellerInfo?.posts?.length > 0 &&
                                [ ...sellerInfo?.posts ]
                                .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                                .map(post => {
                                    return (
                                        <PostBox 
                                            key={post.id} 
                                            image={post.imageUrls ? post.imageUrls[0] : null} 
                                            post={post} 
                                            video={post.videoUrls ? post.videoUrls : null} 
                                        />
                                    );
                                })
                            }
                        </>
                    }

                    {
                        activeProfileTab === 'reviews' && 
                        <>
                            {
                                sellerReviews.length > 0 && 
                                [ ...sellerReviews ]
                                .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                                .map(post => {
                                    return (
                                        <PostBox 
                                            key={post.id} 
                                            image={post.imageUrls ? post.imageUrls[0] : null} 
                                            post={post} 
                                            video={post.videoUrls ? post.videoUrls : null} 
                                        />
                                    );
                                })
                            }
                        </>
                    }
                    </div>
                </div>
        </div>
    );
}

export default ProfilePostGrid;
